import React, { useEffect, useRef } from 'react';
import { useMsal } from '@azure/msal-react';
import { Game } from '../presentation';
import './Valentines2025.css';

const Valentines2025 = () => {
    const { accounts } = useMsal();
    const gameContainerRef = useRef(null);
    

    
    useEffect(() => {
        if (gameContainerRef.current) {
            // Create a game container with ID
            const gameContainerId = 'game-container-instance';
            const gameContainer = document.createElement('div');
            gameContainer.id = gameContainerId;
            
            // Append the container to our ref element
            gameContainerRef.current.innerHTML = '';
            gameContainerRef.current.appendChild(gameContainer);
            
            // Initialize the game with the container ID (string)
            const game = new Game(gameContainerId);
            game.initialize().catch(console.error);
            
            // Cleanup function
            return () => {
                // Any cleanup if needed
            };
        }
    }, []);
    
    return (
            <div ref={gameContainerRef} className="game-container"></div>
    );
};

export default Valentines2025;